import axios from 'axios';

const editProductDetails = (data) => {
  return axios
    .post(`${process.env.REACT_APP_API_URL}/api/product/editProductDetails`, data)
    .then(res => res)
    .catch(err => err);
};

export default editProductDetails;
